import { usePendingAction } from "./use-pending-action"

/**
 * `window.confirm` gate + the standard pending/toast wrapper — for the
 * destructive admin/desk actions (delete job, remove member, …).
 */
export function useConfirmAction() {
  const { pending, run } = usePendingAction()
  const confirmAction = async (
    message: string,
    fn: () => Promise<unknown>,
    opts?: { success?: string; error?: string },
  ): Promise<boolean> => {
    if (!window.confirm(message)) return false
    return run(fn, opts)
  }
  return { pending, confirmAction }
}
